const popuplink = {
    init() {
        $(document).on('click', 'a.popup-link', (e) =>  {
            const el = e.currentTarget;

            e.preventDefault();

            const url    = $(el).attr('href');
            const width  = $(el).data('width');
            const height = $(el).data('height');

            window.open(url, '', `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height}`);
        });
    },
};

export default popuplink;
